import { create, type StoreApi } from 'zustand';
import { devtools } from 'zustand/middleware';

interface GlobalFloatingAlertsSlice {
  fromValidateEmail: boolean;
  setFromValidateEmail: (value: boolean) => void;
  resetGlobalFloatingAlerts: () => void;
}

interface MenuSlice {
  isMenuOpen: boolean;
  setIsMenuOpen: (value: boolean) => void;
}

interface OrderSlice {
  isProcessing: boolean;
  setIsProcessing: (value: boolean) => void;
}

interface AppStore extends GlobalFloatingAlertsSlice, MenuSlice, OrderSlice {}

const createGlobalFloatingAlertsSlice = (
  set: StoreApi<AppStore>['setState']
): GlobalFloatingAlertsSlice => ({
  fromValidateEmail: false,
  setFromValidateEmail: (value: boolean) => set({ fromValidateEmail: value }),
  resetGlobalFloatingAlerts: () => set({ fromValidateEmail: false })
});

const createMenuSlice = (set: StoreApi<AppStore>['setState']): MenuSlice => ({
  isMenuOpen: false,
  setIsMenuOpen: (value: boolean) => set({ isMenuOpen: value })
});

const createOrderSlice = (set: StoreApi<AppStore>['setState']): OrderSlice => ({
  isProcessing: localStorage.getItem('isProcessing') === 'true',
  setIsProcessing: (value: boolean) => {
    if (!value) {
      localStorage.removeItem('isProcessing');
    } else {
      localStorage.setItem('isProcessing', 'true');
    }
    set({ isProcessing: value });
  }
});

export const useAppStore = create<AppStore>()(
  devtools(
    (set) => ({
      ...createGlobalFloatingAlertsSlice(set),
      ...createMenuSlice(set),
      ...createOrderSlice(set)
    }),
    {
      name: 'pext-web-store'
    }
  )
);

export const useSelectFromValidateEmail = () => useAppStore((state) => state.fromValidateEmail);
export const useResetGlobalFloatingAlerts = () =>
  useAppStore((state) => state.resetGlobalFloatingAlerts);
export const useSetFromValidateEmail = () => useAppStore((state) => state.setFromValidateEmail);
export const useSelectIsMenuOpen = () => useAppStore((state) => state.isMenuOpen);
export const useSetIsMenuOpen = () => useAppStore((state) => state.setIsMenuOpen);
